import axios from "axios";
import { ArmorGrouping, ArmorSet } from "../interfaces/armor";
import { Modifier } from "../interfaces/modifier";
import { httpDelete, httpGet, httpPost, httpPut } from "./http-calls";
import { cloneDeep } from "lodash";
import { addStatsToArmor } from "../views/armor/business-logic/armor-helper";
import { store } from "../redux/configure-store";
import { CharacterActions } from "../redux/reducers/character-reducer";
const siteHost: string =
  process.env.REACT_APP_NODE_MODE === "development"
    ? `http://localhost:3001`
    : `https://nest-typeorm.herokuapp.com`;

export const getCharacterArmor = async (charId: string) => {
  const url = `/api/armor/char/${charId}`;
  return await httpGet(url)
    .then((data) => {
      return data as ArmorSet[];
    })
    .catch((err) => {
      throw new Error(err.message);
    });
};
export const createArmorGrouping = async (
  charId: number,
  body: ArmorGrouping
) => {
  return await httpPost(`/api/armor/char/${charId}`, { ...body })
    .then((results) => results)
    .catch((err) => {
      throw new Error(err.message);
    });
};

export const updateArmorLines = async (charId: string, body: Modifier[]) => {
  const url = `/api/armor/updates/${charId}`;
  return await httpPut(url, body)
    .then((results) => {
      const armorList = cloneDeep(results.armors);
      addStatsToArmor(armorList, results.stats?.dex.value ?? 0);
      store.dispatch(
        CharacterActions.setCharacter({ ...results, armors: armorList })
      );
      return { ...results, armors: armorList };
    })
    .catch((err) => {
      throw new Error(err.message);
    });
};

export const saveArmorLine = async (charId: string, body: any) => {
  return await httpPost(`/api/armor/${charId}`, body)
    .then((results) => {
      const armorList = cloneDeep(results.armors);
      addStatsToArmor(armorList, results.stats?.dex.value ?? 0);
      store.dispatch(
        CharacterActions.setCharacter({ ...results, armors: armorList })
      );
      return { ...results, armors: armorList };
    })
    .catch((err) => {
      throw new Error(err.message);
    });
};

export const deleteArmorLine = async (charId: string, acID: string) => {
  const url = `/api/armor/${charId}/${acID}`;
  return await httpDelete(url)
    .then((results) => {
      const armorList = cloneDeep(results.armors);
      addStatsToArmor(armorList, results.stats?.dex.value ?? 0);
      store.dispatch(
        CharacterActions.setCharacter({ ...results, armors: armorList })
      );
      return { ...results, armors: armorList };
    })
    .catch((err) => {
      throw new Error(err.message);
    });
};

export const pinArmor = async (charId: string, id: string) => {
  const url = `/api/armor/char/${charId}/pin/${id}`;
  return await httpPut(url, {})
    .then((results) => results)
    .catch((err) => {
      throw new Error(err.message);
    });
};

export const unpinArmor = async (charId: string, id: string) => {
  const url = `/api/armor/char/${charId}/unpin/${id}`;
  return await httpPut(url, {})
    .then((results) => results)
    .catch((err) => {
      throw new Error(err.message);
    });
};

export const deleteArmorSet = async (charId: string, acId: string) => {
  const url = `/api/armor/char/${charId}/${acId}`;
  return await httpDelete(url)
    .then((results) => results)
    .catch((err) => {
      throw new Error(err.message);
    });
};
